module.exports = __webpack_public_path__ + "img/twitter.de7bc69e.svg";